import React from 'react';
import { Stack, StackProps, Typography } from '@mui/material';
import GridFilledIcon from '../../assets/images/svg/gridFilled.svg';
import GridOutlineIcon from '../../assets/images/svg/gridOutline.svg';
import SquareFilledIcon from '../../assets/images/svg/squareFilled.svg';
import SquareOutlineIcon from '../../assets/images/svg/squareOutline.svg';
import Separator from '../../assets/images/svg/GridSelectionSeparator.svg';
import { tGridTemplateColumns } from '../../react-pages/HomePage/OurProducts/OurProducts';
import Image from 'next/image';

interface CardGridHeaderProps extends StackProps {
  gridColumns: tGridTemplateColumns;
  setGridColumns: React.Dispatch<React.SetStateAction<tGridTemplateColumns>>;
  headerTitle: string | React.ReactNode;
  titleIcon?: React.ReactNode;
  titleStackProps?: StackProps;
  switchStackProps?: StackProps;
}

export const CardGridHeader: React.FC<CardGridHeaderProps> = ({
  gridColumns,
  setGridColumns,
  headerTitle,
  titleIcon,
  titleStackProps,
  switchStackProps,
  sx,
  ...rest
}) => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: { xs: 'space-between', md: 'center' },
        ...sx,
      }}
      {...rest}
    >
      <Stack flexDirection={'row'} gap='12px' alignItems={'center'} {...titleStackProps} sx={{ minHeight: 67, ...sx }}>
        {titleIcon}
        {typeof headerTitle === 'string' || headerTitle instanceof String ? (
          <Typography
            variant='h1'
            component='span'
            sx={{
              color: '#181818',
              textAlign: { xs: 'start', md: 'center' },
            }}
          >
            {headerTitle ?? ''}
          </Typography>
        ) : (
          headerTitle
        )}
      </Stack>

      <Stack
        {...switchStackProps}
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          ...switchStackProps?.sx,
        }}
      >
        {gridColumns === '1fr' ? (
          <>
            <Image
              src={GridOutlineIcon}
              alt=''
              onClick={() => setGridColumns('1fr 1fr')}
              style={{ cursor: 'pointer' }}
            />
            <Image src={Separator} alt='separator' />
            <Image src={SquareFilledIcon} alt='' onClick={() => setGridColumns('1fr')} style={{ cursor: 'pointer' }} />
          </>
        ) : (
          <>
            <Image
              src={GridFilledIcon}
              alt=''
              onClick={() => setGridColumns('1fr 1fr')}
              style={{ cursor: 'pointer' }}
            />
            <Image src={Separator} alt='separator' />
            <Image src={SquareOutlineIcon} alt='' onClick={() => setGridColumns('1fr')} style={{ cursor: 'pointer' }} />
          </>
        )}
      </Stack>
    </Stack>
  );
};
